module.exports = __webpack_public_path__ + "assets/img/arrowLeft.fc95af6b.svg";